var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlertCircleFill = function SvgIconAlertCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 1.5 0v3.75zm-.75 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z",
    fill: "#FE9739",
    fillRule: "evenodd"
  })));
};
export default SvgIconAlertCircleFill;